export const extendedExpiryAtoms: string[] = [
    'passengerStateAtom',
    'selectedPassengersPerTypeStateAtom',
];

export const whitelistedAtoms: string[] = [
    'selectedPassengerForCancelAtom',
    'selectedPassengerForCancelInBoundAtom',
    'selectedBookingIdForCancelAtom',
    'displayPassengerDataAtom',
    'selectedTripsDataAtom',
    'tripDisableForCancelSelectionAtom',
    'cancelBookingConfirmPopupFlagAtom',
    'selectedBookingTripStatusAtom',
    'bookingResponseAtom',
    // Persisted alongside bookingResponseAtom and isChangeDateStateAtom, which
    // are here so a change-date checkout survives the /checkout/cancel reload.
    // Without it, cancelling on the MPGS page (or any F5 mid-checkout) restores
    // the flow but empties this atom, so isCdtExchangeForBooking goes false and
    // the retry omits refundLegs: the train moves and the shuttle stays booked
    // on the original date. clearBookingFlowAtoms still clears it on every fresh
    // flow entry, so the abandoned-change-date guard it exists for still holds.
    'quickExchangeBookingResponseAtom',
    'userDataAtom',
    'isAuthenticatedStateAtom',
    'tokenStateAtom',
    'customerContactStateAtom',
    'searchStateAtom',
    'inboundSearchStateAtom',
    'selectedTrainStateAtom',
    'selectedInboundTrainStateAtom',
    'selectedDateAtom',
    'inboundSelectedDateAtom',
    'trainShuttleBookingAtom',
    'selectedPassengersAtom',
    'selectedPassengersOutBoundAtom',
    'selectedPassengersInBoundAtom',
    'allPassengerPriceAndAgeGroupAtom',
    'allPassengerPriceAndAgeGroupInBoundAtom',
    'passengerTypesStateAtom',
    'selectedPassengersPerTypeStateAtom',
    'paymentOutBoundItemsDetailsAtom',
    'paymentInboundItemsDetailsAtom',
    'refundOfferResponseAtom',
    'refundFeeAtom',
    'refundableAmountAtom',
    'outboundShuttleState',
    'inboundShuttleState',
    'contentDetailAtom',
    // Checkout flow atoms
    'checkoutUserDataAtom',
    'checkoutPaymentSummaryAtom',
    'confirmAddonsPassengerListAtom',
    'paymentStateAtom',
    'savedPassengerDetailAtom',
    'passengerMappingAtom',
    'areAllPassengerDetailsCompleteAtom',
    'guestCheckoutBookingIdAtom',
    'pendingBookingDataAtom',
    // Seating atoms
    'selectedSeatsAtom',
    'originalSeatsAtom',
    'confirmedSeatsAtom',
    'selectedCoachAtom',
    'placeMapResponseAtom',
    'coachLayoutResponseAtom',
    'floorPlanIconsResponseAtom',
    // Voucher atoms
    // 'voucherCodeAtom',
    // 'voucherErrorAtom',
    // 'listOfAppliedVoucherAtom',
    // Booking request/response atoms
    'bookingRequestAtom',
    'offerAtom',
    'selectedOfferIdAtom',
    'selectedOutboundTrainAtom',
    'selectedInboundTrainAtom',
    // Trip and train summary atoms
    'tripOfferAtom',
    'nextAndPreviousTrainAtom',
    // 'trainAtom',
    'defaultActiveKeyForTripSummaryAtom',
    'tripLegsDetailsAtom',
    'selectedTrainLegsAtom',
    'filterTrainsAtom',
    'visibleTrainsAtom',
    'isAnonymousStateAtom',
    'selectedPassengersPerTypeStateAtom',
    "passengerStateAtom",
    'isHyperFastStateAtom',
    // Earn points atoms — must survive payment cancel page reload so loyalty banner persists on checkout
    'earnPointsTotalAtom',
    'earnExtraPointsAtom',
    // Manage-seating refund queue — persisted so it survives a page refresh
    // mid-checkout. Read by buildSessionAncillaries on Pay-click and sent
    // in the /api/payment/session body so the backend can settle the refund
    // as part of the gateway session. Cleared on manage-seating flow entry.
    'pendingRefundFulfillmentIdsAtom',
    // Refund-quote cache from the manage-seating entry probe — persisted for
    // the same reason as the queue above: a page refresh mid-checkout must
    // not lose the cached refundOfferIds. Cleared on flow entry.
    'refundOffersByFulfillmentIdAtom',
    // Aftersales flow flags — persisted so they survive the payment cancel
    // redirect (`/checkout/cancel` → full-reload to `/checkout`). Without
    // this, the checkout page rehydrates the booking but treats it as a new
    // booking, which incorrectly fires the upsell `replacement-offers` call
    // among other new-booking-only effects. Cleared by SearchInitStep /
    // ProceedToOnHoldAction / ResetManageSeatingStateAction on fresh flow
    // entry.
    'isManageSeatingAtom',
    'isChangeDateStateAtom',
    'isQuickExchangeStateAtom',
    'isUpgradeToPremiumStateAtom',
];